module.exports = __webpack_public_path__ + "media/images/icons/mail-fe3157bd97f93a3a4cc9390d251a53fc.svg";